import { render, staticRenderFns } from "./Diario.vue?vue&type=template&id=6da448b6&scoped=true&"
import script from "./Diario.vue?vue&type=script&lang=js&"
export * from "./Diario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da448b6",
  null
  
)

export default component.exports